import MedicalBookingApp from "./Assets/Projects/khambenh.jpg";

export const PROJECTS = [
  {
    image: MedicalBookingApp,
    name: "Online Medical Appointment Booking System",
    technologyUsed: "ReactJs, JavaScript, Redux, NodeJs, MySQL, Sequelize",
    description:
      "A web-based medical appointment booking system that allows patients to schedule doctor visits online. The platform provides features like multi-language support, patient management, doctor scheduling, medical history tracking, and automated email confirmations. Built with a secure and scalable architecture to enhance the healthcare booking experience.",
    url: "Your deployment link here",
  },
];

export const SKILLS = [
  { name: "ReactJs", initialRating: 4 },
  { name: "React-Native", initialRating: 4 },
  { name: "JavaScript", initialRating: 4 },
  { name: "Redux", initialRating: 4 },
  { name: "Shopify/Reactjs", initialRating: 4 },
  { name: "Nodejs", initialRating: 3 },
  { name: "Html", initialRating: 4 },
  { name: "CSS", initialRating: 4 },
  { name: "Unit-Testing(Jest)", initialRating: 3 },
  { name: "TypeScript", initialRating: 4 },
  { name: "AntD | ReactStrap | Material UI", initialRating: 4 },
  { name: "Git", initialRating: 4 },
];

export const TOOLS = [
  "Visual Studio Code",
  "Git",
  "Chrome DevTools",
  "Npm (Node Package Manager)",
  "Atom",
  "Sublime Text",
  "Linux",
  "Heroku",
  "Postman",
];
